import React from "react";

function IntroB({ image = "IntroB.svg" }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        padding: "24px 8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Logos area */}
      <div style={{ display: "flex", alignContent: "center",  justifyContent: "center", width: "80%", maxWidth: "900px" }}>
        <img
          src={"/assets/walkthrough/ECHO.svg"}
          alt="ECHO and ESA Logos"
          style={{
            width: "40%",
            height: "auto"
          }}
        />
      </div>
      {/* Scenario box as image container */}
      <div
        style={{
          background: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          width: "80%",
          maxWidth: 800,
          minHeight: 180,
          margin: "40px 0",
          padding: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={image}
          alt="Scenario Illustration"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}

export default IntroB;
